import useSWR from 'swr';

interface StaffMember {
  id: number;
  username: string;
  display_name?: string | null;
  avatar_display_url?: string | null;
  position?: string | null;
  organization?: string | null;
  bio?: string | null;
  telegram_username?: string | null;
  website?: string | null;
  role?: { name: string; color?: string | null; priority?: number | null } | null;
  work_time?: string | null;
  work_since?: string | null;
  articles_count?: number;
  projects_count?: number;
  projects?: Array<{ id: number; name: string; role?: string | null }>;
  /** Посещений за последние 10 дней (для размера пузырька) */
  visits_last_10_days?: number;
  /** Посещений за последние 30 дней (0 = скрыть пузырёк) */
  visits_last_30_days?: number;
}

// Хук для получения списка сотрудников
export function useStaff(limit: number = 20) {
  const { data, error, isLoading, isValidating, mutate } = useSWR<StaffMember[]>(
    `/api/auth/staff/?limit=${limit}`,
    {
      // Сотрудники редко меняются — раз в 10 минут
      refreshInterval: 600000,
      revalidateIfStale: true,
    }
  );

  return {
    staff: Array.isArray(data) ? data : [],
    isLoading,
    isValidating,
    error,
    mutate,
  };
}
